<template>
  <v-card flat class="mb-2 mt-2" rounded="lg">
    <v-card-subtitle class="subtitle-1 font-weight-bold black--text pb-1"
      >Código Cliente Supermecado</v-card-subtitle
    >
    <v-card-text>
      <span
        class="headline green--text text--darken-4"
        :style="{
          'letter-spacing': '7px !important',
          'font-family': 'Archivo Black !important',
        }"
        >{{ usuarioLogado.matrcoasul }}</span
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("usuario", ["usuarioLogado"]),
};
</script>

<style>
</style>